module.exports = __webpack_public_path__ + "static/img/video_icon2_2.e7d113d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/broadcast/video_icon2_2.png
// module id = c2UK
// module chunks = 0